import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
const sales = [{
  name: 'Mateo R.',
  location: 'Bogotá, Colombia',
  time: 'Hace 2 minutos',
  img: 'https://i.pravatar.cc/150?u=mateo123'
}, {
  name: 'Valentina C.',
  location: 'Ciudad de México',
  time: 'Hace 12 minutos',
  img: 'https://i.pravatar.cc/150?u=valentina456'
}, {
  name: 'Sebastián L.',
  location: 'Medellín, Colombia',
  time: 'Hace 23 minutos',
  img: 'https://i.pravatar.cc/150?u=sebastian789'
}, {
  name: 'Camila P.',
  location: 'Madrid, España',
  time: 'Hace 41 minutos',
  img: 'https://i.pravatar.cc/150?u=camila321'
}, {
  name: 'Diego A.',
  location: 'Miami, USA',
  time: 'Hace 1 hora',
  img: 'https://i.pravatar.cc/150?u=diego654'
}, {
  name: 'Laura G.',
  location: 'Santiago, Chile',
  time: 'Hace 2 horas',
  img: 'https://i.pravatar.cc/150?u=laura987'
}];
export function RecentSalesPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Initial delay before showing the first popup (3 seconds)
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 3000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide the popup after 4 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      // Show the next popup after a random delay between 3 to 6 seconds
      const nextDelay = Math.floor(Math.random() * 3000) + 3000;
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % sales.length);
        setIsVisible(true);
      }, nextDelay);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, currentIndex]);
  const currentSale = sales[currentIndex];
  return <div className={`fixed bottom-6 left-4 sm:left-6 z-50 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0 pointer-events-none'}`} data-id="element-181">
      <div className="bg-noir-card border border-noir-border border-l-2 border-l-noir-alert p-3 rounded-sm shadow-[0_5px_20px_rgba(0,0,0,0.8)] flex items-center space-x-4 max-w-sm w-full" data-id="element-182">
        <img src={currentSale.img} alt={currentSale.name} className="w-12 h-12 rounded-full object-cover border border-noir-border flex-shrink-0 grayscale-[20%]" data-id="element-183" />
        <div className="flex flex-col" data-id="element-184">
          <div className="flex items-center flex-wrap gap-x-1" data-id="element-185">
            <span className="text-noir-text font-bold text-sm font-mono" data-id="element-186">
              {currentSale.name}
            </span>
            <span className="text-xs text-noir-muted" data-id="element-187">
              de {currentSale.location}
            </span>
          </div>
          <p className="text-xs text-noir-text font-sans mt-0.5" data-id="element-188">
            Acaba de comprar{' '}
            <span className="font-bold text-noir-alert" data-id="element-189">Expediente Pareja</span>
          </p>
          <div className="flex items-center space-x-1 mt-1.5" data-id="element-190">
            <CheckCircle2 className="w-3 h-3 text-green-600" data-id="element-191" />
            <span className="text-[10px] text-noir-muted font-mono uppercase tracking-wider" data-id="element-192">
              Compra Verificada • {currentSale.time}
            </span>
          </div>
        </div>
      </div>
    </div>;
}